(function () {
  function $(sel, root = document) { return root.querySelector(sel); }
  function escapeHtml(s) {
    return (s || "").replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  }

  function initOne(section) {
    const input = $(".ps-searchbar-input", section);
    const box = $(".ps-search-suggest", section);
    if (!input || !box) return;

    let t = null;
    let last = "";

    function closeBox() {
      box.hidden = true;
      box.innerHTML = "";
    }

    async function fetchSuggestions(q) {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`;
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) return null;
      return res.json();
    }

    function render(data) {
      const products = data?.resources?.results?.products || [];
      if (!products.length) { closeBox(); return; }

      const html = products.map(p => {
        const title = escapeHtml(p.title);
        const type = escapeHtml(p.product_type || "");
        const url = p.url;
        const img = p.image ? p.image : "";
        return `
          <a class="ps-suggest-item" href="${url}">
            <img class="ps-suggest-thumb" src="${img}" alt="${title}">
            <div>
              <div class="ps-suggest-title">${title}</div>
              ${type ? `<div class="ps-suggest-meta">${type}</div>` : ``}
            </div>
          </a>
        `;
      }).join("");

      box.innerHTML = html;
      box.hidden = false;
    }

    input.addEventListener("input", () => {
      const q = input.value.trim();
      if (q.length < 2) { closeBox(); return; }
      if (q === last) return;

      last = q;
      clearTimeout(t);
      t = setTimeout(async () => {
        try {
          const data = await fetchSuggestions(q);
          if (!data) return;
          // Prevent stale render
          if (input.value.trim() !== q) return;
          render(data);
        } catch (e) {
          closeBox();
        }
      }, 200);
    });

    input.addEventListener("focus", () => {
      const q = input.value.trim();
      if (q.length >= 2) input.dispatchEvent(new Event("input"));
    });

    document.addEventListener("click", (e) => {
      if (!section.contains(e.target)) closeBox();
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeBox();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ps-searchbar]').forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
